// import HomeBack from '../../assets/images/lock-logo.png'


export const loginObjOne = {
    id: 'about',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    pageHeading: 'Login',
    pagePara: 'or create an account',
    form:'loginForm',
    imgStart: false,
    img: require('../../assets/images/jobDashlogo.png'),
    alt: 'Car',
    dark: true,
    primary: true,
    darkText: false
}

export const signUpObjOne = {
    id: 'about',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    pageHeading: 'Sign up',
    pagePara: 'or create an account',
    form: "signupForm",
    imgStart: false,
    img: require('../../assets/images/jobDashlogo.png'),
    alt: 'Car',
    dark: true,
    primary: true,
    darkText: false
}

export const forgotObjOne = {
    id: 'about',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    pageHeading: 'Forgot Password',
    pagePara: 'We need to verify your account, your data will be secured and private.',
    form: "forgotForm",
    imgStart: false,
    img: require('../../assets/images/jobDashlogo.png'),
    alt: 'Car',
    dark: true,
    primary: true,
    darkText: false
}

export const resetObjOne = {
    id: 'about',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    pageHeading: 'Reset Password',
    pagePara: `Enter the new password then your password will be changed! Don't forgot again.`,
    form: "resetForm",
    imgStart: false,
    img: require('../../assets/images/jobDashlogo.png'),
    alt: 'Car',
    dark: true,
    primary: true,
    darkText: false
}

export const restaurantDetailsObjOne = {
    id: 'about',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    pageHeading: 'Personal Details',
    pagePara: '',
    form: "restaurantDetailsForm",
    imgStart: false,
    img: require('../../assets/images/jobDashlogo.png'),
    alt: 'Car',
    dark: true,
    primary: true,
    darkText: false
}

export const bankDetailsObjOne = {
    id: 'about',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    pageHeading: 'Bank Details',
    form: "bankDetailsForm",
    pagePara: '',
    imgStart: false,
    img: require('../../assets/images/jobDashlogo.png'),
    alt: 'Car',
    dark: true,
    primary: true,
    darkText: false
}

export const verifyOtpObjOne = {
    id: 'about',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    pageHeading: `Enter Verification Code`,
    pagePara: `We have sent you 4 digit verification code on your registered mobile number`,
    form: "verifyOtp",
    imgStart: false,
    img: require('../../assets/images/jobDashlogo.png'),
    alt: 'Car',
    dark: true,
    primary: true,
    darkText: false
}

export const pendingApprovalObjOne = {
    id: 'about',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    pageHeading: `Waiting for the confirmation.`,
    pagePara: `"Your details has been sent for admin to get verified. Once verified, we'll sent you confirmation mail to your registered mail address and after that you can access the same."`,
    form: "pendingApproval",
    imgStart: false,
    img: require('../../assets/images/jobDashlogo.png'),
    alt: 'Car',
    dark: true,
    primary: true,
    darkText: false
}
